import React, { useState } from 'react';
import { showAppAlert } from '../utils/alertService';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function AddPoliciesModal({ visible, onClose, onAdd }) {
  const [descricao, setDescricao] = useState('');
  const [status, setStatus] = useState('1');
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');

  if (!visible) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      textPolicy: descricao,
      status: Number(status),
    };

    try {
      const response = await fetch(`${API_URL}/policies`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.status === 201) {
        showAppAlert('success', 'Política cadastrada com sucesso');
        setDescricao('');
        setStatus('1');
        if (onAdd) onAdd();
        onClose();
      } else {
        showAppAlert('error', data.message || 'Política não cadastrada');
      }
    } catch (error) {
      showAppAlert('error', 'Política não cadastrada');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Cadastrar Políticas</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Descrição:</label>
            <textarea
              name="descricao"
              value={descricao}
              onChange={e => setDescricao(e.target.value)}
              required
              className="input-style"
            />
          </div>
          <div className="form-group">
            <label>Status:</label>
            <select
              name="status"
              value={status}
              onChange={e => setStatus(e.target.value)}
              className="input-style"
            >
              <option value="1">Ativo</option>
              <option value="0">Inativo</option>
            </select>
          </div>
          <div className="button-container">
            <button type="submit" className="button-style" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
            <button type="button" className="button-style cancel" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddPoliciesModal;